import { render } from "./saleBox.vue?vue&type=template&id=2857f720"
import script from "./saleBox.vue?vue&type=script&lang=js"
export * from "./saleBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__